var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildHoverIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_222_1366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5 68H21.5C16.529 68 12.5 63.971 12.5 59V31.295C12.5 28.025 14.273 25.016 17.129 23.429L35.129 13.43C37.847 11.921 41.153 11.921 43.871 13.43L61.871 23.429C64.727 25.016 66.5 28.028 66.5 31.295V59C66.5 63.971 62.471 68 57.5 68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6143 14.3041C37.9547 13.0047 40.786 12.964 43.1572 14.182L43.3857 14.3041L61.3857 24.3031C63.9243 25.7139 65.5 28.3918 65.5 31.2953V59.0004C65.4998 63.4189 61.9186 67.0004 57.5 67.0004H21.5C17.0814 67.0004 13.5002 63.4189 13.5 59.0004V31.2953C13.5 28.4795 14.979 25.8811 17.3799 24.4388L17.6143 24.3031L35.6143 14.3041Z",
    stroke: "#1D4B48",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_222_1366",
    x: 0.5,
    y: 0.298218,
    width: 78,
    height: 79.7018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113725 0 0 0 0 0.294118 0 0 0 0 0.282353 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_222_1366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_222_1366",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildHoverIc);
export default __webpack_public_path__ + "static/media/buildHover_ic.2aa44dc9048fb7f03c7cd7164bfd8297.svg";
export { ForwardRef as ReactComponent };